import React from 'react';

import { DynamicProductTable } from '../_dynamic';
import { ProductTableProps } from '../_dynamic/constants';

import { tableHead } from './constants';
import ProductItem from './item';

export const TreasuryTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      tableHeadItems={tableHead}
      tabletColumns={3}
      tabletRows={1}
      mobileFields={[
        { key: 'movementDate', label: 'Solicitação' },
        { key: 'movementType', label: 'Tipo' },
        { key: 'clientName', label: 'Cliente' },
        { key: 'issuerName', label: 'Emissor' },
        { key: 'bondType', label: 'Ativo' },
        { key: 'rateValue', label: 'Taxa' },
        { key: 'maturityDate', label: 'Vencimento' },
        { key: 'financial', label: 'Valor' },
        { key: 'statusDescription', label: 'Status' },
      ]}
    />
  );
};
